import {
  accessGroupErrorFragment,
  permissionGroupErrorFragment
} from "@saleor/fragments/errors";
import { permissionGroupDetailsFragment } from "@saleor/fragments/permissionGroups";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  AccessGroupUpdate,
  AccessGroupUpdateVariables
} from "./types/PermissionGroup2FA";
import {
  PermissionGroupCreate,
  PermissionGroupCreateVariables
} from "./types/PermissionGroupCreate";
import {
  PermissionGroupDelete,
  PermissionGroupDeleteVariables
} from "./types/PermissionGroupDelete";
import {
  PermissionGroupUpdate,
  PermissionGroupUpdateVariables
} from "./types/PermissionGroupUpdate";

export const permissionGroupDelete = gql`
  ${permissionGroupErrorFragment}
  mutation PermissionGroupDelete($id: ID!) {
    permissionGroupDelete(id: $id) {
      errors: permissionGroupErrors {
        ...PermissionGroupErrorFragment
      }
    }
  }
`;
export const usePermissionGroupDelete = makeMutation<
  PermissionGroupDelete,
  PermissionGroupDeleteVariables
>(permissionGroupDelete);

export const permissionGroupCreate = gql`
  ${permissionGroupDetailsFragment}
  ${permissionGroupErrorFragment}

  mutation PermissionGroupCreate($input: PermissionGroupCreateInput!) {
    permissionGroupCreate(input: $input) {
      errors: permissionGroupErrors {
        ...PermissionGroupErrorFragment
      }
      group {
        ...PermissionGroupDetailsFragment
      }
    }
  }
`;

export const usePermissionGroupCreate = makeMutation<
  PermissionGroupCreate,
  PermissionGroupCreateVariables
>(permissionGroupCreate);

export const permissionGroupUpdate = gql`
  ${permissionGroupDetailsFragment}
  ${permissionGroupErrorFragment}

  mutation PermissionGroupUpdate(
    $id: ID!
    $input: PermissionGroupUpdateInput!
  ) {
    permissionGroupUpdate(id: $id, input: $input) {
      errors: permissionGroupErrors {
        ...PermissionGroupErrorFragment
      }
      group {
        ...PermissionGroupDetailsFragment
      }
    }
  }
`;

export const usePermissionGroupUpdate = makeMutation<
  PermissionGroupUpdate,
  PermissionGroupUpdateVariables
>(permissionGroupUpdate);

export const updateAccessGroup = gql`
  ${accessGroupErrorFragment}

  mutation AccessGroupUpdate(
    $accessGroupId: ID!
    $name: String!
    $code: String!
    $description: String!
  ) {
    accessGroupUpdate(
      id: $accessGroupId
      input: { name: $name, code: $code, description: $description }
    ) {
      accessGroup {
        id
        name
        code
        description
        createdAt
        updatedAt
      }
      errors: accessGroupErrors {
        ...AccessGroupErrorFragment
      }
    }
  }
`;

export const useUpdateAccessGroup = makeMutation<
  AccessGroupUpdate,
  AccessGroupUpdateVariables
>(updateAccessGroup);
